function initQuoteGalleryCarousel() {
    let $quoteGalleryScroll = $('.quote-gallery__slider');
    let autoplay = $quoteGalleryScroll.attr('data-auto-play');
    if($quoteGalleryScroll.length < 1) return;

    $quoteGalleryScroll.slick({
        dots: false,
        infinite: true,
        arrows: true,
        speed: 1000,
        slidesToShow: (autoplay === 'true' || autoplay === 'True') ? 2 : 1,
        slidesToScroll: 1,
        autoplay: !!(autoplay === 'true' || autoplay === 'True'),
        autoplaySpeed: 5000,
        mobileFirst: false,
        responsive: [
            {
                breakpoint: 769,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: '20%'
                }
            }
        ]
    });
}

function showImageOrVideo() {
    var showVideo = $(this).attr('data-show-video');
    if(showVideo === 'true' || showVideo === 'True') {
        var src = $(this).attr('data-video');
        var video = '<div class="iframe-container video-iframe"><iframe src="' + src + '"frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen="" title="Lofoten from Above" data-ready="true"></iframe></div>';
        $('#quote-gallery-modal-video').html(video);
        $('#quote-gallery-modal-image').hide();
        $('.quote-gallery-modal .isa-modal__content').addClass('p-0');
    } else {
        if($('.quote-gallery-modal .isa-modal__content').hasClass('p-0')) { $('.quote-gallery-modal .isa-modal__content').removeClass('p-0'); }
        $('#quote-gallery-modal-image').show();
        var $img = $(this).find('.quote-gallery__slide-image');
        $('#quote-gallery-modal-image').attr('src', $img.attr('src'));
    }
}

$(function () {
    initQuoteGalleryCarousel();

    $('.quote-gallery__slider').on('beforeChange', function () {
        $('.quote-gallery__content').addClass('content-animation');
    });
    $('.quote-gallery__slider').on('afterChange', function () {
        var $currentSlide = $(this).find('.slick-current').attr('data-slick-index');
        $('.quote-gallery__content').hide();
        $('#quote-gallery-content' + $currentSlide).show();
        $('.quote-gallery__content').removeClass('content-animation');
    });

    $('.quote-gallery__slide-image-container').on('click', showImageOrVideo);

    $('#quote-image-modal').on('hidden.bs.modal', function () {
        $('#quote-gallery-modal-video').html('');
        $('#quote-gallery-modal-image').attr('src', '');
    });
});
